let UTILS = require("../libs/utils.js");
var v7775;
var v7776;
module.exports = {
  id: "aon",
  name: "All or Nothing",
  alias: "aon",
  preventCustomGames: true,
  tag: ["Event", "#d95487", "#e86b9b"],
  event: 4,
  endStats: ["sid", "name", "score", "kills", "deaths", "reward"],
  leaderStats: ["score", "kills"],
  onKill: function (game, p9295, p9296, p9297) {
    var v7777 = p9296.lastGround && (!p9297 || p9297 == p9296);
    if (p9297 && p9297 != p9296 || v7777) {
      if (p9296.lastGround && !p9296.onGround) {
        v7777 = true;
      }
      var vO219 = {
        x: v7777 ? p9296.lastGround.x : p9296.x,
        y: v7777 ? p9296.lastGround.y : p9296.y,
        z: v7777 ? p9296.lastGround.z : p9296.z
      };
      var v7778 = p9296.ammos[0] || 0;
      game.dropSpawnable(6, p9296, {
        xD: p9296.xDire + UTILS.toRad(90),
        c: v7778
      }, vO219);
      if (UTILS.randInt(1, 100) <= 30) {
        game.dropSpawnable(8, p9296, null, vO219);
      }
    }
    if (p9297 && p9297 != p9296 && p9297.killStreak >= 5 && UTILS.randInt(1, 100) >= 50) {
      game.players.giveEffect(p9297, UTILS.getRandom([0, 2, 9]));
    }
  },
  doubleXP: true,
  forceSpawn: 3,
  forceClass: 9,
  ammoLimit: 0,
  noReloads: true,
  noPickups: true,
  randClassScr: 0.5,
  noScrLimit: true,
  noKnives: true,
  startingLoadout: [16],
  disabledStreaks: [4, 5, 6]
};